export default class CryptoAddressVerification {
    constructor() {
        this.id = 0;
        this.userId = 0;
        this.status = null;
        this.currencyToCheckId = 0;
        this.currencyToPaymentId = 0;
        this.address = '';
        this.amount = 0;
        this.createdAt = 0;
    }
}
